// /src/pdf/builders/loyalty/buildDoc.js
export function buildLoyaltyDoc({
  t, shortcode, stationName,
  date,
  resultText, // plain text (без HTML)
  period,     // локализованная строка из UI
  logoDataUrl,
  serviceName
}) {
  const content = [];
  const stationTitle = stationName || shortcode || '';
  const serviceTitle = serviceName || (t && t('loyalty.title')) || '';

  // Лого слева (если доступно)
  if (logoDataUrl) {
    content.push({ image: logoDataUrl, width: 140, margin: [0, 0, 0, 10] });
  }

  // Шапка: название радио + дата + подпись
  content.push(
    ...(serviceTitle ? [{ text: serviceTitle, style: 'h1', margin: [0, 0, 0, 2] }] : []),
    ...(stationTitle ? [{ text: stationTitle, style: 'h1', margin: [0, 0, 0, 4] }] : []),
    {
      margin: [0, 0, 0, 6],
      fontSize: 10,
      color: '#666',
      stack: [
        `${t('retention.end_date')}: ${date}`
      ],
    },
    {
      text: (t && t('pdf.made_on')) || 'Report made on Radiomonitor.net',
      fontSize: 10,
      color: '#666',
      margin: [0, 0, 0, 10],
    }
  );

  // Основной результат
  if (resultText) {
    content.push({
      text: resultText,
      fontSize: 12,
      bold: true,
      margin: [0, 0, 0, 6]
    });
  }

  // Пояснение периода
  if (period) {
    content.push({
      text: period,
      color: '#666',
      fontSize: 10
    });
  }

  return {
    pageSize: 'A4',
    pageMargins: [24, 28, 24, 36],
    footer: (current, totalPages) => ({
      margin: [24, 0, 24, 12],
      fontSize: 9,
      columns: [
        { text: `${(t && t('pdf.made_on')) || 'Report made on Radiomonitor.net'}`, alignment: 'left' },
        { text: `${current} / ${totalPages}`, alignment: 'right' },
      ],
    }),
    content,
    styles: {
      h1: { fontSize: 18, bold: true },
    },
  };
}

export { buildLoyaltyDoc as default };
